import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import Mint from 'mint-ui'
import moment from 'moment'

import router from './router'
import store from './store'
import utils from './util/util'

import 'mint-ui/lib/style.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/common.scss'
import mui from './assets/js/mui.min.js'
Vue.use(Mint)

Vue.use(mui)

window.mui = mui


Vue.prototype.utils = utils;
Vue.prototype.mui = mui

moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
    if (localStorage.getItem('wxdl') == '1') {
      let referrer = localStorage.getItem('referrer')
      if (referrer) {
        referrer = decodeURIComponent(referrer)
        localStorage.setItem('referrer','')
        next({ path: referrer })
      } else {
        next()
      }
    } else {
      next()
    }
})
router.afterEach( ( to, from, next ) => {
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf('micromessenger') != -1;
  let arr = ['HomeGoodsdetail','HomeIndex','HomeStoredetail']
  if (isWeixin&&arr.indexOf(to.name) === -1) {
    utils.hideShare()
  }
  setTimeout(()=>{
          var _hmt = _hmt || [];
          (function() {
              document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
              var hm = document.createElement("script");
              hm.src = "https://hm.baidu.com/hm.js?27c3df777fc02d49cd357ddf7226778c";
              hm.id = "baidu_tj"
              var s = document.getElementsByTagName("script")[0];
              s.parentNode.insertBefore(hm, s);
          })();
  },0);
} );
new Vue({
    store,
    router,
  render: h => h(App),
}).$mount('#app')
// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: { App },
//     template: '<App/>'
// })
